import React from 'react';
import {XMarkIcon} from '@heroicons/react/24/outline';
import {useProspectPoolTotalScoreRankHistoriesQuery} from 'api';
import useSearchParams from '../../useSearchParams';
import {TableHeader} from './TableHeader';
import {ScoreHistoryRow} from './ScoreHistoryRow';
import NewTaskModal from '../NewTaskModal';

export const ScoreHistoryTable: React.FC = () => {
  const {searchParams} = useSearchParams();

  const {data: {prospectPoolTotalScoreRankHistories = []} = {}} =
    useProspectPoolTotalScoreRankHistoriesQuery({
      variables: {
        filter: searchParams,
      },
    });

  const [selectedHistories, setSelectedHistories] = React.useState<string[]>(
    [],
  );
  const [taskModalVisible, setTaskModalVisible] = React.useState(false);

  const handleSelectHistory = (historyId: string) => {
    setSelectedHistories((prev) => {
      if (prev.includes(historyId)) {
        return prev.filter((id) => id !== historyId);
      } else {
        return [...prev, historyId];
      }
    });
  };

  // 選択された履歴のprospect_pool_idを取得
  const getSelectedProspectPoolIds = () => {
    return prospectPoolTotalScoreRankHistories
      .filter((history) => selectedHistories.includes(history.id))
      .map((history) => history.prospectPool?.id);
  };

  return (
    <div className="bg-white border border-c-border rounded">
      <table className="w-full">
        <TableHeader />
        {selectedHistories.length > 0 && (
          <thead>
            <tr>
              <th colSpan={9} className="bg-gray-100 px-4 py-2">
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setSelectedHistories([])}
                    className="w-6 h-6 flex items-center justify-center text-gray-600 hover:text-gray-800 bg-transparent cursor-pointer rounded-full hover:bg-gray-200 transition-colors">
                    <XMarkIcon className="w-4 h-4" />
                  </button>
                  <span className="text-gray-700">
                    {selectedHistories.length}件選択中
                  </span>
                  <button
                    className="rounded bg-white text-gray-700 px-2 py-1 cursor-pointer hover:bg-gray-50"
                    onClick={() => setTaskModalVisible(true)}>
                    ToDo登録
                  </button>
                </div>
              </th>
            </tr>
          </thead>
        )}
        <tbody>
          {prospectPoolTotalScoreRankHistories.map((history) => (
            <ScoreHistoryRow
              key={history.id}
              history={history}
              isSelected={selectedHistories.includes(history.id)}
              onSelect={handleSelectHistory}
            />
          ))}
        </tbody>
      </table>
      <NewTaskModal
        selectedProspectPoolIds={getSelectedProspectPoolIds()}
        visible={taskModalVisible}
        onClose={() => setTaskModalVisible(false)}
        onSuccess={() => {
          setSelectedHistories([]);
        }}
      />
    </div>
  );
};
